document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.psp-flip-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.psp-flip-card, .psp-lens-card');
      if (!card) return;
      var flipped = card.classList.toggle('is-flipped');
      btn.setAttribute('aria-pressed', flipped ? 'true' : 'false');
    });
  });
});
